/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Content.ContentHost_
///   This is an auto-generated enumeration of the SWFC_Learning.Content.ContentHost domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum ContentHost_ {
   /// <summary>
   ///   Rustici SCORM Cloud (rustsc)
   /// </summary>
   SCORMCloud = 1,
   /// <summary>
   ///   The Princeton Review (tpr)
   /// </summary>
   TPR = 2
}

export const ContentHosts: ContentHost[] = [
   {
      code: ContentHost_.SCORMCloud,
      literal: 'SCORMCloud',
      description: 'Rustici SCORM Cloud',
      shortDescription: 'rustsc',
      listPriority: 0,

      name: 'SCORM Cloud',

      registrationTokenPattern: '{LearnerToken={ContactId}.{QualifiedHostedContentToken={ContentHost.Literal}.{AppId(from host)}.{ContentToken(from host)}}',

      postbackClientId: 'c61400746df3458094c3bb19bd547fec',

      postbackClientSecret: 'ZmVlMWI1ZTUtNzQzOC00NWUwLWFhNjUtMGI0Mzk5ODljZDdm',

      typeName: "ContentHost"
   },
   {
      code: ContentHost_.TPR,
      literal: 'TPR',
      description: 'The Princeton Review',
      shortDescription: 'tpr',
      listPriority: 0,

      name: 'The Princeton Review',

      registrationTokenPattern: '',

      postbackClientId: null,

      postbackClientSecret: null,

      typeName: "ContentHost"
   }
]

export class ContentHost implements IDomainModel {
   code: ContentHost_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   name: string

   registrationTokenPattern: string

   postbackClientId: string

   postbackClientSecret: string

   typeName: string

   static toDomainModel(code: ContentHost_): ContentHost {
      return ContentHosts.find(d => d.code === code)
   }
}
